// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3yxgk","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2-hIa"};